var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAttach24Px = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m21.89 11.275-9.43 9.43s-4.377 4.378-8.419.336c-4.041-4.041.337-8.42.337-8.42l9.767-9.766s2.694-2.694 5.388 0 0 5.389 0 5.389l-9.43 9.43s-1.347 1.347-2.694 0c-1.347-1.348 0-2.695 0-2.695l8.756-8.756"
})));
export default SvgAttach24Px;